export default {
    namespaced: true,
    state: {
        formKeyWords: '',
    },
    mutations: {
        changeFormKeyWords(state, data) {
            state.formKeyWords = data;
        },
    },
    action: {},
    getter: {},
};
